import React from "react";
import { Route, Redirect, HashRouter } from "react-router-dom";
import App from "./App";
import Login from "./pages/Login";
import { isAuthenticated } from "./services/Auth";

const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      isAuthenticated() ? <Component {...props} /> : <Redirect to={"/login"} />
    }
  />
);

const Routes = () => (
  <HashRouter>
    <div>
      <Route path="/login" component={Login} />
      <PrivateRoute path="/" component={App} />
    </div>
  </HashRouter>
);

export default Routes;
